import { render } from "./StockBarang.vue?vue&type=template&id=b66ec98e&scoped=true"
import script from "./StockBarang.vue?vue&type=script&lang=js"
export * from "./StockBarang.vue?vue&type=script&lang=js"

import "./StockBarang.vue?vue&type=style&index=0&id=b66ec98e&scoped=true&lang=css"
import "./StockBarang.vue?vue&type=style&index=1&id=b66ec98e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b66ec98e"]])

export default __exports__